"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _colors = require("../../config/colors");

require("../../../css/ToggleButton.css");

var ToggleButton = function ToggleButton(_ref) {
  var isOpen = _ref.isOpen;
  return (
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "toggle-button",
      type: "button"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: isOpen ? _proLightSvgIcons.faChevronUp : _proLightSvgIcons.faChevronDown,
      size: "1x",
      color: _colors.CHEVRON_COLOR
    }))
  );
};

ToggleButton.propTypes = process.env.NODE_ENV !== "production" ? {
  isOpen: _propTypes["default"].bool.isRequired
} : {};

var _default = exports["default"] = ToggleButton;